import { useState, useEffect } from 'react';

const API_BASE_URL = 'https://portalapply.online';

export const useActiveListings = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchAllActiveListings = async () => {
      console.log('🔄 Starting to fetch active listings...');
      setIsLoading(true);
      setIsError(false);
      
      try {
        let allListings = [];
        let hasMore = true;
        let nextCursor = null;
        let totalCount = 0;
        let pageCount = 0;

        // Fetch all pages of active listings
        while (hasMore) {
          pageCount++;
          const url = nextCursor 
            ? `${API_BASE_URL}/api/v1/listings/active?limit=1000&cursor=${nextCursor}`
            : `${API_BASE_URL}/api/v1/listings/active?limit=1000`;
          
          console.log(`📄 Fetching page ${pageCount}:`, url);
          
          const response = await fetch(url);
          console.log('📡 Response status:', response.status, response.statusText);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const result = await response.json();
          console.log('📊 API Response:', result);
          console.log('📊 Response structure:', {
            hasItems: !!result.items,
            itemsType: Array.isArray(result.items) ? 'array' : typeof result.items,
            itemsLength: result.items?.length || 0,
            hasMore: result.hasMore,
            nextCursor: result.nextCursor,
            total: result.total,
            returned: result.returned
          });
          
          if (result.items && Array.isArray(result.items)) {
            console.log(`✅ Found ${result.items.length} items on page ${pageCount}`);
            console.log('📋 Sample item:', result.items[0]);
            allListings = [...allListings, ...result.items];
          } else {
            console.log('⚠️ No items array in response or not an array');
          }
          
          hasMore = result.hasMore || false;
          nextCursor = result.nextCursor || null;
          totalCount = result.total || allListings.length;
          
          console.log('🔄 Pagination info:', { hasMore, nextCursor, totalCount });
        }

        console.log('🎉 Final results:', {
          totalListings: allListings.length,
          totalCount,
          pagesFetched: pageCount,
          apiTotal: totalCount,
          actualCount: allListings.length
        });

        // Use the API's total count (from database) as the accurate count
        const finalCount = totalCount > 0 ? totalCount : allListings.length;
        
        console.log('🔢 Using count:', finalCount, '(API total from database)');
        console.log('📊 Comparison:', {
          apiTotal: totalCount,
          itemsFetched: allListings.length,
          usingCount: finalCount
        });

        setData({
          listings: allListings,
          totalCount: totalCount,
          count: finalCount
        });
      } catch (error) {
        console.error('❌ Error fetching active listings:', error);
        console.error('❌ Error details:', {
          message: error.message,
          stack: error.stack
        });
        setIsError(true);
        setData({
          listings: [],
          totalCount: 0,
          count: 0
        });
      } finally {
        console.log('🏁 Finished fetching active listings');
        setIsLoading(false);
      }
    };

    fetchAllActiveListings();
  }, []);

  return { data, isLoading, isError };
};
